import { faCaretDown, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Listbox } from "@headlessui/react";
import clsx from "clsx";
import { Fragment, useState } from "react";
import { render } from "react-dom";

export interface IListItem
{
    value: string
    title: string
    tag: keyof JSX.IntrinsicElements // 'JSX' is not defined               no-undef
    style?: React.CSSProperties //  'React' is not defined             no-undef
}

export type ListProperties<T extends IListItem> =
{
    value: string
    title?: string
    icon?: IconDefinition
    placeholder?: string,
    // items: T[]
    // renderItem?: (item: T, selected: boolean) => JSX.Element
    onSelect?: (value: string) => void // 'value' is defined but never used  no-unused-vars
    onChange?: (value: string) => void // 'value' is defined but never used  no-unused-vars
    className?: string
    children: any
}

export function ListItem(properties: IListItem)
{
    const { value, title, style } = properties;
    const element =
    <Listbox.Option key={value} value={value} as={Fragment}>
        {
            ({ selected }) =>
            <li style={style} className={selected ? 'selected' : ''}>
                <properties.tag>{title}</properties.tag>
            </li>
        }
    </Listbox.Option>;
    return element;
}

export function List<T extends IListItem>({ value, title, icon, onSelect, onChange, className = 'menu', placeholder = '', children }: ListProperties<T>)
{
    const showTitle = !onSelect;
    const titleClass = showTitle ? (title ? '' : 'placeholder') : '';
    const list =
    <Listbox as="div" value={value} onChange={onChange} className={className}>
        <Listbox.Button className={'btn'}>
            <span className={titleClass}>{showTitle && (title || placeholder)}</span>
            <FontAwesomeIcon icon={faCaretDown} className="caret" />
        </Listbox.Button>
        <Listbox.Options className='menu-content'>
            {children}
        </Listbox.Options>
    </Listbox>;
    const element = onSelect
        ?   <div className="btn-group">
                <button type="button" className="btn" onClick={() => onSelect(value)}>
                    {icon ? <FontAwesomeIcon icon={icon} /> : title}
                </button>
                {list}
            </div>
        :   list;
    return element;
}